var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"quarter-switch-item-container",class:{ selected: _vm.selectedValue === _vm.itemValue },attrs:{"type":"button"},on:{"click":_vm._emit}},[_vm._v(" "+_vm._s(_vm.itemLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }